export const iconFontAwesomeCommunicationMicrophoneLines = (
	<i className="fa-solid fa-microphone-lines"></i>
);
